export enum TYPES {
  STORE = "store",
  LIVE_CARP = "livecarp",
  CARPSALE = "carpsale",
}

export const TYPES_NAME = {
  [TYPES.STORE]: "飼育資材ストア購入履歴",
  [TYPES.LIVE_CARP]: "ライブ鯉の購入履歴",
  [TYPES.CARPSALE]: "錦鯉販売の購入履歴",
};

export const TYPES_ARRAY = [
  { id: TYPES.STORE, name: TYPES_NAME[TYPES.STORE] },
  { id: TYPES.LIVE_CARP, name: TYPES_NAME[TYPES.LIVE_CARP] },
  { id: TYPES.CARPSALE, name: TYPES_NAME[TYPES.CARPSALE] },
];

export enum STATUSES {
  INITIAL = "initial",
  RESERVED = "reserved",
  CONFIRMED = "confirmed",
  PACKING = "packing",
  STOCK = "stock",
  SENTED = "sented",
  CANCEL = "cancel",
}

export const STATUS_NAME = {
  [STATUSES.INITIAL]: "未確認",
  [STATUSES.RESERVED]: "手続き済",
  [STATUSES.CONFIRMED]: "入金待ち",
  [STATUSES.PACKING]: "準備中",
  [STATUSES.STOCK]: "預かり中",
  [STATUSES.SENTED]: "発送済",
  [STATUSES.CANCEL]: "キャンセル",
};

export const STATUS_LABEL_LIVECARP = {
  [STATUSES.INITIAL]: "未手続き",
  [STATUSES.RESERVED]: "手続き済",
  [STATUSES.PACKING]: "発送待ち",
  [STATUSES.SENTED]: "完了",
};

export const STATUS_NAME_LIVECARP = {
  [STATUSES.INITIAL]: "未手続き",
  [STATUSES.RESERVED]: "手続き済",
  [STATUSES.PACKING]: "発送待ち(ポイント付与)",
  [STATUSES.SENTED]: "完了(ポイント付与)",
};

export const STATUS_NAME_CARPSALE = {
  [STATUSES.INITIAL]: "未確認",
  [STATUSES.CONFIRMED]: "入金待ち",
  [STATUSES.PACKING]: "準備中",
  [STATUSES.SENTED]: "発送済（ポイント付与）",
  [STATUSES.CANCEL]: "キャンセル",
};

export const STATUS_NAME_STORE = {
  [STATUSES.INITIAL]: "未確認",
  [STATUSES.CONFIRMED]: "入金待ち",
  [STATUSES.PACKING]: "準備中",
  [STATUSES.SENTED]: "発送済（ポイント付与）",
  [STATUSES.CANCEL]: "キャンセル",
};

export const STATUS_ARRAY = [
  { id: STATUSES.INITIAL, name: STATUS_NAME[STATUSES.INITIAL] },
  { id: STATUSES.RESERVED, name: STATUS_NAME[STATUSES.RESERVED] },
  { id: STATUSES.CONFIRMED, name: STATUS_NAME[STATUSES.CONFIRMED] },
  { id: STATUSES.PACKING, name: STATUS_NAME[STATUSES.PACKING] },
  { id: STATUSES.STOCK, name: STATUS_NAME[STATUSES.STOCK] },
  { id: STATUSES.SENTED, name: STATUS_NAME[STATUSES.SENTED] },
  { id: STATUSES.CANCEL, name: STATUS_NAME[STATUSES.CANCEL] },
];

export const STATUS_ARRAY_LIVECARP = [
  { id: STATUSES.INITIAL, name: STATUS_LABEL_LIVECARP[STATUSES.INITIAL] },
  { id: STATUSES.RESERVED, name: STATUS_LABEL_LIVECARP[STATUSES.RESERVED] },
  { id: STATUSES.PACKING, name: STATUS_LABEL_LIVECARP[STATUSES.PACKING] },
  { id: STATUSES.SENTED, name: STATUS_LABEL_LIVECARP[STATUSES.SENTED] },
];

export const STATUS_ARRAY_CARPSALE = [
  { id: STATUSES.INITIAL, name: STATUS_NAME[STATUSES.INITIAL] },
  { id: STATUSES.CONFIRMED, name: STATUS_NAME[STATUSES.CONFIRMED] },
  { id: STATUSES.PACKING, name: STATUS_NAME[STATUSES.PACKING] },
  { id: STATUSES.SENTED, name: STATUS_NAME[STATUSES.SENTED] },
  { id: STATUSES.CANCEL, name: STATUS_NAME[STATUSES.CANCEL] },
];

export enum PAYMENT_TYPES {
  BANK = "Bank",
  COD = "C.O.D",
  DIRECT = "Direct",
}

export const PAYMENT_TYPES_NAME = {
  [PAYMENT_TYPES.BANK]: "銀行振込",
  [PAYMENT_TYPES.COD]: "代金引換",
  [PAYMENT_TYPES.DIRECT]: "店頭支払",
};

export enum DELIVERY_PREFERRED_TIME {
  NOT_SPECIFIED = 1,
  MORNING = 2,
  TIME_14_16 = 3,
  TIME_16_18 = 4,
  TIME_18_20 = 5,
  TIME_19_21 = 6,
}

export const DELIVERY_PREFERRED_TIME_NAME = {
  [DELIVERY_PREFERRED_TIME.NOT_SPECIFIED]: "指定しない",
  [DELIVERY_PREFERRED_TIME.MORNING]: "午前中",
  [DELIVERY_PREFERRED_TIME.TIME_14_16]: "14時-16時",
  [DELIVERY_PREFERRED_TIME.TIME_16_18]: "16時〜18時",
  [DELIVERY_PREFERRED_TIME.TIME_18_20]: "18時〜20時",
  [DELIVERY_PREFERRED_TIME.TIME_19_21]: "19時〜21時",
};

export enum DELIVERY_TYPES {
  DELIVERY = "Delivery",
  STORE = "Store",
}

export const DELIVERY_TYPES_NAME = {
  [DELIVERY_TYPES.DELIVERY]: "配送する",
  [DELIVERY_TYPES.STORE]: "店頭受け取り",
};
